import "./App.css";
import About from "./components/about/About";
import Contact from "./components/contact/Contact";
import Home from "./components/home/Home";
import Skill from "./components/project/Skill";
import Project from "./components/works/Project";
import { motion } from "framer-motion";
function App() {
  return (
    <>
      <motion.div
        className="section"
        id="home"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        transition={{ duration: 1.5, ease: "easeInOut" }}
      >
        <Home />
      </motion.div>
      <motion.div
        className="section"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        transition={{ duration: 1.5, ease: "easeInOut" }}
        id="about"
      >
        <About />
      </motion.div>
      <motion.div
        className="section"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        transition={{ duration: 1.5, ease: "easeInOut" }}
        id="skills"
      >
        <Skill />
      </motion.div>
      <motion.div
        className="section"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 1, y: 20 }}
        whileInView={{
          transition: { duration: 1.5, ease: "easeInOut" },
          animate: { opacity: 1 },
        }}
        id="project"
      >
        <Project />
      </motion.div>
      <motion.div
        className="section"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        transition={{ duration: 2.5 }}
        id="contact"
      >
        <Contact />
      </motion.div>
    </>
  );
}

export default App;
